import { isEmpty } from '@ember/utils'
import { isArray, mergeWith } from 'lodash'

export default function transposeObjects<T extends Record<string, any>>(
  objects: T[],
): { [K in keyof T]?: Array<T[K]> } {
  // changes an array of objects of values to an object of key-named arrays of values
  // ie [{'name': 'joker','age': 23}, {'name': 'batman', 'age': 44}, {'name': 'catwoman', 'age': 22, 'favecolour': 'black'}]
  // becomes... {'name':['joker', 'batman', 'catwoman'], 'age':[23, 44, 22], 'favecolour':['black']}
  if (isEmpty(objects)) return {}
  // turn the values of each object into an array, then split out the first and rest for merging.
  const [firstArrayValueObject, ...restArrayValueObjects] = objects.map((object) => {
    const newObject: { [K in keyof T]?: Array<T[K]> } = {}
    for (const key in object) {
      newObject[key] = [object[key]]
    }
    return newObject
  })
  const customizer = (objValue: Array<T[keyof T]> | undefined, srcValue: Array<T[keyof T]>) => {
    if (isArray(objValue)) {
      return objValue.concat(srcValue)
    } else {
      // this is here because sometimes the keys might not be in all the objects
      return srcValue
    }
  }
  return restArrayValueObjects.reduce((item, acc) => {
    return mergeWith(item, acc, customizer)
  }, firstArrayValueObject)
}
